L.Icon.Default.imagePath = '/images/leaflet/'  # Pokud máš vlastní ikonky, uprav podle potřeby

maps = {}
markers = []
bounds = null

initMap = (id) ->
  el = document.getElementById(id)

  return null unless el

  map = L.map(id).setView([50.2225, 17.1892], 15)

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    # attribution: '&copy; OpenStreetMap contributors'
  ).addTo(map)

  maps[id] = map
  return map


# status_map = initMap 'status_map'
drivers_map = initMap 'drivers_map'
summary_map = initMap 'summary_map'

drivers = {}
fitted = false

animateMove = (marker, newLatLng, duration = 250, steps = 5) ->
  oldLatLng = marker.getLatLng()
  step = 0

  deltaLat = (newLatLng.lat - oldLatLng.lat) / steps
  deltaLng = (newLatLng.lng - oldLatLng.lng) / steps

  interval = setInterval ->
    step += 1
    if step >= steps
      marker.setLatLng(newLatLng)
      clearInterval(interval)
    else
      marker.setLatLng(
        L.latLng(
          oldLatLng.lat + deltaLat * step,
          oldLatLng.lng + deltaLng * step
        )
      )
  , duration / steps

showDrivers = ->

  return false unless $('#map_modal').is(':visible')
  
  $.ajax
    url: '/ajax/online_drivers.script'
    type: 'POST'
    dataType: 'JSON'
    data:
      ahoj: 'ahoj'

  .done (data) ->
    used_ids = {}

    for key, value of data.drivers
      continue unless value.lat > 0 and (value.online_status or value.logged_status == 'online' or value.on_map == 1)

      id = value.user_id
      used_ids[id] = true
      latLng = L.latLng(value.lat, value.lng)

      icon = L.icon
        iconUrl: '../images/' + value.icon
        iconSize: value.icon_size
        iconAnchor: value.anchor

      popupContent = "<strong style='text-align: center;'>" + value.name + "</strong>"

      if drivers[id]?
        marker = drivers[id]

        console.log "Updating marker for driver #{id}"


        # Změna pozice (animovaně)
        if !marker.getLatLng().equals(latLng)
          animateMove(marker, latLng)

        # Změna ikony
        if marker.options.icon.options.iconUrl != icon.options.iconUrl
          marker.setIcon(icon)

        # Změna popupu
        marker.setPopupContent(popupContent)

      else

        console.log "Adding marker for driver #{id}"

        marker = L.marker(latLng, {icon: icon, title: value.name})
          .bindPopup(popupContent)
          .addTo(maps['drivers_map'])

        drivers[id] = marker

    # Odstranit neaktivní
    for id of drivers
      unless used_ids[id]
        maps['drivers_map'].removeLayer(drivers[id])
        delete drivers[id]


    # Fit jen když není otevřený žádný popup
    popupOpen = maps['drivers_map']._popup? and maps['drivers_map'].hasLayer(maps['drivers_map']._popup)
    fitMap(maps['drivers_map']) unless fitted or popupOpen
    return

  .fail (jqXHR) ->
    console.error jqXHR.responseText
    return


# Start
# showDrivers()
setInterval showDrivers, 5000


clearMap = (map) ->
  for id, layer of map._layers
    if layer instanceof L.Marker or layer instanceof L.Polyline
      map.removeLayer(layer)

showOnMapPath = (map, path) ->
  icon = L.icon
    iconUrl: '../images/ride-ball.png'
    iconSize: [10, 10]
    iconAnchor: [5, 5]

  for point in path
    lat = parseFloat(point.lat)
    lng = parseFloat(point.lng)
    m = L.marker([lat, lng], {icon: icon}).addTo(map)
    markers.push(m)

  # fitMap map

showOnMap = (map, lat, lng, markerName = 'ride.png') ->
  icon = L.icon
    iconUrl: '../images/' + markerName
    iconSize: [25, 41]
    iconAnchor: [12, 41]

  lat = parseFloat(lat)
  lng = parseFloat(lng)
  m = L.marker([lat, lng], {icon: icon}).addTo(map)
  markers.push(m)

  # fitMap map
  return

fitMap = (map) ->
  markers = []


  for id, layer of map._layers
    if layer instanceof L.Marker
      markers.push(layer)

  console.log('fit', markers)


  return unless markers.length > 0

  bounds = L.latLngBounds(markers.map (m) -> m.getLatLng())
  
  map.fitBounds(bounds, {
    padding: [
      map.getSize().y * 0.15,  # výška
      map.getSize().x * 0.15   # šířka
    ]
  })
